import { render } from "./ExpandableRow.vue?vue&type=template&id=c3741492"
import script from "./ExpandableRow.vue?vue&type=script&lang=js"
export * from "./ExpandableRow.vue?vue&type=script&lang=js"
script.render = render

export default script